import Vue from 'vue'
import { lsSet, lsGet, lsDel } from '../utils/ls'
import { deepCopy } from '../utils/assist'
import hash from "../utils/hash-it"

// tin uid
var uid = 1
// 异步存储队列
var queue = []
var has = {}
var waiting = false
// 执行状态
var flushing = false

// localStorage更新队列
function queueTin(tin) {
    var id = tin.id
    
    // 去重
    if (has[id] == null) {
        has[id] = true
        
        queue.push(tin)
        
        if (!waiting) {
            waiting = true
            Vue.nextTick(() => flush())
        }
    }
}

// 队列执行
function flush() {
    var data = {}
    
    flushing = true
    
    for (var index = 0; index < queue.length; index++) {
        var tin = queue[index],
            id = tin.id,
            path = tin.path,
            hashKey = tin.hashKey
        
        has[id] = null
        
        // 路由空间可能未创建
        if (!data[path]) {
            data[path] = lsGet(path, {})
        }
        
        // 更新时间戳
        tin.data.timestamp = now()
        
        // 覆盖更新
        data[path][hashKey] = tin.data
    }
    
    // 刷新localStorage
    Object.keys(data).forEach(path => {
        lsSet(path, data[path])
    })
    
    waiting = false
    queue = []
}

// 时间戳
function now() {
    return new Date().getTime()
}

// 存储罐
function Tin(options) {
    this.init(options)
}

Object.assign(Tin.prototype, {
    init(options = {}) {
        // props
        // 响应式数据
        this.state = Vue.observable({
            value: null
        })
        this.id = uid++
        this.options = options
        
        Object.keys(this.options).forEach(key => {
            Object.defineProperty(this, key, {
                configurable: true,
                get: () => {
                    return this.options[key]
                }
            })
        })
        
        // 主键
        this.hashKey = this.getHashKey()
        
        // restore from localStorage
        var lst = lsGet(this.path, {}),
            data = lst[this.hashKey]
        
        // localStorage存储格式
        this.data = Object.assign({
            key: this.key,
            value: this.defaultVal, // 值
            query: this.query, // 查询字符串
            userId: this.userId, // 用户id
            timestamp: now() // 时间戳
        }, data)
        
        // state
        this.state.value = deepCopy(this.data.value)
        
        // getters
        Object.defineProperty(this, "value", {
            enumerable: false,
            configurable: false,
            get: () => {
                // timeout controll
                if (this.overtime()) {
                    this.state.value = undefined
                    
                    return this.options.defaultVal
                }
                
                return typeof this.state.value == "undefined" ? this.options.defaultVal : this.state.value
            }
        })
        
        // watch
        var tin = this
        this.watcher = new Vue({
            created() {
                // value发生变化后，更新localStorage缓存
                this.$watch(() => tin.state.value, val => {
                	tin.data.value = deepCopy(tin.state.value)
                	queueTin(tin)
                }, {
                    deep: true,
                })
            }
        })
    },
    
    getHashKey() {
        return hash(this.key + '-' + this.query + '-' + this.userId)
    },
    
    // 更新值
    update(val, force = false) {
        // 持久化更新
        if (force || val !== this.state.value) {
            this.state.value = val
        }
    },
    
    // 是否超时
    overtime() {
        return this.expire > 0 && (now() - this.data.timestamp) / 1000 > this.expire
    },
})

export default Tin